import request from '@/utils/http';

// 集群配置-初始化页面
export const getESIndex = (params) => {
    return request({
        url: '/api-sn/config/esConfig/search',
        method: 'post',
        data: params
    }).then(res => res);
};

// 集群配置-修改/新增
export const changeInfo = (params) => {
    return request({
        url: '/api-sn/config/esConfig/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 集群配置状态更改
export const changeState = (params) => {
    return request({
        url: '/api-sn/config/esConfig/avail',
        method: 'post',
        data: params
    }).then(res => res);
};

// 集群配置，获取地址列表
export const getAdress = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/search',
        method: 'post',
        data: params
    }).then(res => res);
};

// 集群配置，地址状态更改
export const changeAdressState = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/avail',
        method: 'post',
        data: params
    }).then(res => res);
};
// 集群配置-地址的增加修改
export const adressCut = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 租户集群绑定
export const clusterBinding = (params) => {
    return request({
        url: `/api-sn/config/tenantEsConfig/tenantBindInfo/${params}`,
        method: 'get'
    });
};

// 新增/修改ES集群配置明细(地址修改)
export const changeSite = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 获取ES集群配置明细(地址)
export const getSite = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// oss-分頁、获取初始数据
export const getOss = (params) => {
    return request({
        url: '/api-sn/config/ossConfig/search',
        method: 'post',
        data: params
    }).then(res => res);
};

// oss新增修改
export const changeOss = (params) => {
    return request({
        url: '/api-sn/config/ossConfig/save',
        method: 'post',
        data: params
    }).then(res => res);
};
// oss状态
export const changeOssState = (params) => {
    return request({
        url: '/api-sn/config/ossConfig/avail',
        method: 'post',
        data: params
    }).then(res => res);
};

// OSS删除
export const deleteOss = (id) => {
    return request({
        url: `/api-sn/config/ossConfig/delete/${id}`,
        method: 'get'
    });
};

// 限额（quota）-分頁、获取初始数据
export const getQuota = (params) => {
    return request({
        url: '/api-sn/config/quotaConfig/search',
        method: 'post',
        data: params
    }).then(res => res);
};

// quota状态
export const changeQuotaState = (params) => {
    return request({
        url: '/api-sn/config/quotaConfig/avail',
        method: 'post',
        data: params
    }).then(res => res);
};

// quota修改，新增
export const changeQuota = (params) => {
    return request({
        url: '/api-sn/config/quotaConfig/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// quota删除
export const deleteQuota = (id) => {
    return request({
        url: `/api-sn/config/quotaConfig/delete/${id}`,
        method: 'get'
    });
};

// 租戶集群綁定（tenant）-初始化頁面
export const getTenant = (params) => {
    return request({
        url: '/api-sn/config/tenantEsConfig/search',
        method: 'post',
        data: params
    }).then(res => res);
};

// 新增修改ES（地址）集群配置明细
export const addressDetail = (params) => {
    return request({
        url: '/api-sn/config/esConfig/detail/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 新增租户提交
export const newQuota = (params) => {
    return request({
        url: '/api-sn/config/tenantEsConfig/batchSaveOrDelte',
        method: 'post',
        data: params
    }).then(res => res);
};

// 查询租户列表
export const tenantList = (params) => {
    return request({
        url: `/api-auth/subTenants/${params}`,
        method: 'get'
    });
};

// 企业注册信息-新增
export const newCompany = (params) => {
    return request({
        url: '/api-sn/enterprise/save',
        method: 'post',
        data: params
    }).then(res => res);
};

// 企业注册信息-查询
export const searchCompany = (params) => {
    return request({
        url: `/api-sn/enterprises/${params}`,
        method: 'get'
    });
};

// 企业注册-分页查询
export const CompanyPage = (params) => {
    return request({
        url: '/api-sn/enterprise/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};
// 标识属性-清空分页（查询）
export const searchAttribute = (params) => {
    return request({
        url: '/api-sn/identity/identityAttrReg/search',
        method: 'post',
        data: params
    }).then(res => res);
};
// 新增-标识属性
export const newAttribute = (params) => {
    return request({
        url: '/api-sn/identity/identityAttrReg',
        method: 'post',
        data: params
    }).then(res => res);
};

// 最新动态-分页查询
export const searchDynamic = (params) => {
    return request({
        url: '/api-sn/config/trendConfigs',
        method: 'post',
        data: params
    }).then(res => res);
};

export const searchNotic = (params) => {
    return request({
        url: '/api-sn/config/infos',
        method: 'post',
        data: params
    }).then(res => res);
};
// 最新动态-状态修改
export const changeNewsState = (params) => {
    return request({
        url: '/api-sn/config/trendConfigUpdate',
        method: 'post',
        data: params
    }).then(res => res);
};
// 最新动态-单个查询
export const searchSingleNews = (params) => {
    return request({
        url: `/api-sn/config/trendConfigDetail/${params}`,
        method: 'get'
    });
};
export const searchNoticOnce = (params) => {
    return request({
        url: `/api-sn/config/infoDetail/${params}`,
        method: 'get'
    });
};
// 最新动态-修改
export const changeSingleNews = (params) => {
    return request({
        url: '/api-sn/config/trendConfigUpdate',
        method: 'post',
        data: params
    }).then(res => res);
};
// 最新动态-新增
export const newSingleNews = (params) => {
    return request({
        url: '/api-sn/config/trendConfig',
        method: 'post',
        data: params
    }).then(res => res);
};

// 最新动态上传视频
export const uploadPictures = (params) => {
    return request({
        url: '/api-file/snFile/upload',
        method: 'post',
        data: params
    }).then(res => res);
};

// 数据字典-列表
export const getDictionaryList = (params) => {
    return request({
        url: '/api-sn/config/dataDictionarys/searchPage',
        method: 'post',
        data: params
    });
};

// 数据字典-新增/修改
export const addAndChageDictionary = (params) => {
    return request({
        url: '/api-sn/config/dataDictionary/save',
        method: 'post',
        data: params
    });
};

// 数据字典-详情列表
export const getDictionaryDetail = (params) => {
    return request({
        url: '/api-sn/config/dataDictionaryDetails/searchPage',
        method: 'post',
        data: params
    });
};

// 数据字典-详情新增/修改
export const addAndChageDicDetail = (params) => {
    return request({
        url: '/api-sn/config/dataDictionaryDetail/save',
        method: 'post',
        data: params
    });
};

// 数据字典-批量查询
export const searchByDictCodes = (params) => {
    return request({
        url: '/api-sn/config/dataDictionaryDetail/searchByDictCodes',
        method: 'get',
        params
    });
};

// 数据字典-删除
export const deleteDictCodes = (params) => {
    return request({
        url: '/api-sn/config/dataDictionary/delete',
        method: 'post',
        data: params
    });
};

// 数据字典-明细删除
export const deleteDetailDictCodes = (params) => {
    return request({
        url: '/api-sn/config/dataDictionaryDetail/delete',
        method: 'post',
        data: params
    });
};
// 调用标识-列表
export const getCallIdentifierList = (params) => {
    return request({
        url: '/api-sn/messageConfig/selectPage',
        method: 'post',
        data: params
    });
};

// 调用标识-新增/修改
export const addAndChageCallIdentifier = (params) => {
    return request({
        url: '/api-sn/messageConfig/saveConfig',
        method: 'post',
        data: params
    });
};

// 美信消息配置-删除
export const deleteMessage = (esId) => {
    return request({
        url: `/api-sn/messageConfig/delete/${esId}`,
        method: 'get'
    });
};

// [租户表关系配置]-查询接口
export const tenantRelSearch = (params) => {
    return request({
        url: '/api-sn/config/tenantSourcesysTables/searchPage',
        method: 'post',
        data: params
    });
};
// [租户表关系配置]-新增接口
export const tenantRelAdd = (params) => {
    return request({
        url: `/api-sn/config/tenantSourcesysTable/save`,
        method: 'post',
        data: params
    });
};

// [租户表关系配置]-修改接口
export const tenantRelEdit = (params) => {
    return request({
        url: `/api-sn/config/tenantSourcesysTable/update/${params.id}`,
        method: 'post',
        data: params
    });
};

// [租户表关系配置]-删除接口
export const tenantRelDetail = (id) => {
    return request({
        url: `/api-sn/config/tenantSourcesysTable/delete/${id}`,
        method: 'get'
    });
};

// 步骤表-查询列表
export const getStepList = (params) => {
    return request({
        url: `/api-sn/step/page`,
        method: 'post',
        data: params
    });
};
// 步骤表-新增
export const addStepSave = (params) => {
    return request({
        url: `/api-sn/step/save`,
        method: 'post',
        data: params
    });
};
// 步骤表-查询明细
export const editStepDetail = (params) => {
    return request({
        url: `/api-sn/step/detail`,
        method: 'post',
        data: params
    });
};
// 步骤表-更新修改
export const updateStepSave = (params) => {
    return request({
        url: `/api-sn/step/update`,
        method: 'post',
        data: params
    });
};

// 步骤表-启用禁用
export const enableOrNotStepSave = (params) => {
    return request({
        url: `/api-sn/step/enableOrNot`,
        method: 'post',
        data: params
    });
};
// 节点表-查询列表
export const getNodeList = (params) => {
    return request({
        url: `/api-sn/node/page`,
        method: 'post',
        data: params
    });
};
// 节点表 - 查询未添加到节点的步骤列表
export const stepNotAddNode = (params) => {
    return request({
        url: `/api-sn/step/notAddNode`,
        method: 'post',
        data: params
    });
};
// 节点表 - 节点保存接口
export const addNodeSave = (params) => {
    return request({
        url: `/api-sn/node/save`,
        method: 'post',
        data: params
    });
};
// 节点表 - 更新节点接口
export const updateNodeSave = (params) => {
    return request({
        url: `/api-sn/node/update`,
        method: 'post',
        data: params
    });
};
// 节点表-修改查询明细
export const editNodeDetail = (params) => {
    return request({
        url: `/api-sn/node/getNode`,
        method: 'post',
        data: params
    });
};
// 节点表-启用禁用
export const enableOrNotNodeSave = (params) => {
    return request({
        url: `/api-sn/node/enableOrNot`,
        method: 'post',
        data: params
    });
};

// 场景表-查询列表
export const getSceneList = (params) => {
    return request({
        url: `/api-sn/scene/page`,
        method: 'post',
        data: params
    });
};
// 场景表-查询未添加到场景的节点列表
export const nodeNotAddScene = (params) => {
    return request({
        url: `/api-sn/node/notAddScene`,
        method: 'post',
        data: params
    });
};
// 场景表 - 场景保存接口
export const addSceneSave = (params) => {
    return request({
        url: `/api-sn/scene/save`,
        method: 'post',
        data: params
    });
};
// 场景表 - 更新场景接口
export const updateSceneSave = (params) => {
    return request({
        url: `/api-sn/scene/update`,
        method: 'post',
        data: params
    });
};
// 场景表-修改查询明细
export const editSceneDetail = (params) => {
    return request({
        url: `/api-sn/scene/getScene`,
        method: 'post',
        data: params
    });
};
// 场景表-查询明细
export const editSceneAll = (params) => {
    return request({
        url: `/api-sn/scene/getTree`,
        method: 'post',
        data: params
    });
};
// 领域表-查询列表
export const sceneDomainList = (params) => {
    return request({
        url: `/api-sn/sceneDomain/page`,
        method: 'post',
        data: params
    });
};
// 领域表-新增
export const addSceneDomainSave = (params) => {
    return request({
        url: `/api-sn/sceneDomain/save`,
        method: 'post',
        data: params
    });
};
// 领域表-修改
export const updateSceneDomainSave = (params) => {
    return request({
        url: `/api-sn/sceneDomain/update`,
        method: 'post',
        data: params
    });
};
// 来源系统-传入领域，获取领域对应的来源系统
export const getSourceSysList = (params) => {
    return request({
        url: `/api-sn/sceneDomain/getSourceSysList`,
        method: 'post',
        data: params
    });
};
// 来源系统-传入领域，获取领域对应的来源系统
export const batchOiTobExecute = (params) => {
    return request({
        url: `/api-sn/barcode/batchOiTob/execute`,
        method: 'post',
        data: params
    });
};
// 单据类型-领域表
export const listByTenantCode = (params) => {
    return request({
        url: `/api-sn/sceneDomain/listByTenantCode`,
        method: 'post',
        data: params
    });
};